export function Loader() {
    console.log("loader");
    return (
        <div className="flex justify-center items-center h-screen w-screen">
            <div className="rounded-full h-20 w-20 bg-theme-primary animate-ping"></div>
        </div>
    )
}